var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('list-table',{attrs:{"requests":_vm.requests}}),(!_vm.requests)?_c('div',{staticClass:"card-disabled"},[_c('div',{staticClass:"loader"})]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }